<template>
  <loader-wrapper :loading="loading">
    <el-collapse-transition>
      <div v-if="auto_selected">
        <el-row style="display: flex; align-items: center" :gutter="24">
          <el-col :span="12">
            <h4>Выберите авто:</h4>
          </el-col>
          <el-col :span="12">
            <el-input
              v-model="search_auto"
              size="mini"
              placeholder="Введите для поиска"
              :disabled="loading"
              @blur="filteredAutoList"
              @keyup.enter.native="filteredAutoList"
            />
          </el-col>
        </el-row>
        <el-table max-height="550" :data="getAutos" style="width: 100%">
          <el-table-column
            label="Организация"
            width="250px"
            prop="carrier_name"
          >
            <template slot-scope="{ row }">
              <span v-if="row.carrier_name">{{ row.carrier_name }}</span>
              <span v-else style="font-size: 12px">Не указано</span>
            </template>
          </el-table-column>
          <el-table-column label="Номер авто" prop="state_numbers" />
          <el-table-column label="Номер прицепа" prop="state_numbers_trailer" />
          <el-table-column align="right">
            <template slot="header" slot-scope="scope">
              <p>Выбрать</p>
            </template>
            <template slot-scope="scope">
              <el-button size="mini" @click="handleSelect('auto', scope.row)">
                Выбрать
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-collapse-transition>
    <el-collapse-transition>
      <div v-if="dispather_selected">
        <p>
          <b>Вы выбрали авто</b>:
          <span style="color: #e6a23c">{{ selected_auto }}</span>
        </p>

        <el-row style="display: flex; align-items: center" :gutter="24">
          <el-col :span="12">
            <h4>Выберите водителя:</h4>
          </el-col>
          <el-col :span="12">
            <el-input
              v-model="search_driver"
              size="mini"
              placeholder="Введите для поиска"
              :disabled="loading"
              @blur="filteredDriverList"
              @keyup.enter.native="filteredDriverList"
            />
          </el-col>
        </el-row>
        <el-table :data="drivers" style="width: 100%">
          <el-table-column label="ИНН" prop="carrier_name" width="250px">
            <template slot-scope="{ row }">
              <span v-if="row.carrier_name">{{ row.carrier_name }}</span>
              <span v-else style="font-size: 12px">Не указано</span>
            </template>
          </el-table-column>
          <el-table-column label="Водитель" prop="fio" />
          <el-table-column align="right">
            <template slot="header" slot-scope="scope">
              <p>Выбрать</p>
            </template>
            <template slot-scope="scope">
              <el-button size="mini" @click="handleSelect('driver', scope.row)">
                Выбрать
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button class="clear-btn-to-auto" @click="clearForm">
          К выбору авто
        </el-button>
      </div>
    </el-collapse-transition>
    <el-collapse-transition>
      <div v-if="price_selected" class="dl_price">
        <el-row v-if="needShowInfoSource" style="margin-bottom: 30px">
          <div class="info">
            <div class="info__title">Откуда узнали о погрузке?</div>
            <el-select
              v-model="info_source_id"
              placeholder="Выберите вариант"
              class="info__select"
            >
              <el-option
                v-for="item in infoSourcesList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <div>
              <span style="color: #e6a23c; font-weight: bold">
                Цена перевозки составит :
              </span>

              <div style="font-weight: bold">
                <template v-if="type !== 'harvest'">
                  {{ day.price_from_storage_driver | getPrice }}
                  <span v-if="type === 'harvest_or_delivery'">
                    (Перевозка),
                  </span>
                </template>
                <template v-if="type !== 'delivery'">
                  {{ day.price_from_field_driver | getPrice }}
                  <span v-if="type === 'harvest_or_delivery'">(Уборка)</span>
                </template>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <span style="font-weight: bold; color: #f56c6c">Внимание!</span>
              <template>
                <div>Для этой погрузки требуется предоставить сзвм</div>
              </template>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="requiredDocuments.length" class="bidDocuments">
          <div class="bidDocuments__title">
            До записи на погрузку удостоверьтесь, что в наличии есть или точно
            будут следующие документы:
          </div>
          <el-checkbox-group
            v-model="documentsChecklist"
            class="bidDocuments__checkboxes"
          >
            <el-checkbox
              v-for="item in requiredDocuments"
              :key="item.id"
              :label="item.id"
              class="bidDocuments__checkboxes-item"
            >
              {{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-row>
        <el-row :gutter="24" style="margin-bottom: 30px">
          <el-col :span="12">
            <div style="display: flex">
              <el-button
                style="width: 100%; margin-top: 30px"
                @click="clearForm"
              >
                К выбору авто
              </el-button>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="display: flex">
              <el-button
                style="width: 100%; margin-top: 30px"
                type="primary"
                :loading="loadingBid"
                :disabled="!isConfirmEnable"
                @click="createBidRequest"
              >
                Добавить отклик
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-collapse-transition>
  </loader-wrapper>
</template>

<script>
import { GET_FILTER_DRIVERS } from '@/store/actions/drivers'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapActions, mapGetters } from 'vuex'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const Responses = RepositoryFactory.get('responses')
const Documents = RepositoryFactory.get('organizations')

export default {
  name: 'DriverList',
  components: { LoaderWrapper },
  props: {
    day: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
    },
    orgId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selected_auto: '',
      selected_carrier_inn: '',
      selected_driver: '',
      bid_request: {
        load_day_id: this.day.id,
        automobile_id: 0,
        driver_id: 0,
      },
      search_driver: '',
      search_auto: '',
      auto_selected: true,
      dispather_selected: false,
      price_selected: false,
      loadingBid: false,
      infoSourcesList: [],
      info_source_id: null,
      requiredDocuments: [],
      documentsChecklist: [],
      loadingDocuments: false,
    }
  },
  computed: {
    ...mapGetters({
      getAutos: 'autos/getAutos',
      drivers: 'drivers/getDrivers',
      getByKey: 'userProfile/getByKey',
      currentUser: 'userProfile/userInfo',
    }),
    loadingAuto() {
      return this.$store.state.autos.loading
    },
    loadingDrivers() {
      return this.$store.state.drivers.loading
    },
    loading() {
      return this.loadingAuto || this.loadingDrivers || this.loadingDocuments
    },
    // опрос "Откуда узнали о заявке" - только для определенных статусов
    needShowInfoSource() {
      return (
        [1, 3, 5, 6].includes(this.currentUser.user_type) &&
        this.infoSourcesList.length
      )
    },
    isConfirmEnable() {
      return (
        this.requiredDocuments.length === this.documentsChecklist.length ||
        !this.requiredDocuments.length
      )
    },
  },
  async mounted() {
    this.fetchAutos()
    const { data } = await Responses.getInfoSources()

    this.infoSourcesList = data

    this.loadingDocuments = true
    let documents = await Documents.getBidRequiredDocuments(this.orgId)

    this.requiredDocuments = documents.data
    this.loadingDocuments = false
  },
  methods: {
    ...mapActions({ fetchAutosNew: 'autos/fetchAutosNew' }),
    fetchAutos(search) {
      this.fetchAutosNew({ org_id: this.curUserOrgId, search })
    },
    filteredAutoList() {
      if (this.search_auto.length > 2) {
        this.fetchAutos(this.search_auto)
      }
      if (this.search_auto.length === 0) {
        this.fetchAutos()
      }
    },
    filteredDriverList() {
      if (this.search_driver.length > 2) {
        this.$store.dispatch(`drivers/${GET_FILTER_DRIVERS}`, {
          fio: this.search_driver,
          carrier_inn: this.selected_carrier_inn,
        })
      }
      if (this.search_driver.length === 0) {
        this.$store.dispatch(`drivers/${GET_FILTER_DRIVERS}`, {
          carrier_inn: this.selected_carrier_inn,
        })
      }
    },
    handleSelect(param, data) {
      if (param === 'auto') {
        const { state_numbers, carrier_inn, id } = data

        this.selected_auto = state_numbers
        this.selected_carrier_inn = carrier_inn
        this.bid_request.automobile_id = id
        this.auto_selected = false
        this.dispather_selected = true
        this.search_auto = ''
        this.filteredDriverList()
      } else if (param === 'driver') {
        const { fio, id } = data

        this.selected_driver = fio
        this.bid_request.driver_id = id
        this.dispather_selected = false
        this.price_selected = true
        this.search_driver = ''
      }
    },
    createBidRequest() {
      this.loadingBid = true
      this.bid_request.user_org_id = this.curUserOrgId

      if (this.info_source_id) {
        this.bid_request.info_source_id = this.info_source_id
      }
      Responses.postResponse(this.bid_request)
        .then(() => this.beforeClose())
        .catch(err => {
          // костыль. Если из админ-интерфейса создаем отклик на день, в котором уже есть
          // отклик на эту машину, то запрашиваем подтверждение и повторно отправляем ее с force_create
          const isDuplicate = err.response.data.find(
            error => error.field === 'response_exists',
          )

          if (isDuplicate) {
            this.$confirm(
              'На данное авто уже есть запись на погрузку в этот день. Вы уверены?',
              'Внимание!',
              {
                confirmButtonText: 'Да',
                cancelButtonText: 'Отмена',
                type: 'warning',
                customClass: 'duplicate-response',
              },
            ).then(() => {
              this.bid_request.force_create = 1
              Responses.postResponse(this.bid_request).then(() =>
                this.beforeClose(),
              )
            })
          } else {
            this.errHandler(err)
          }
        })
        .finally(() => (this.loadingBid = false))
    },
    clearForm() {
      this.bid_request = {
        load_day_id: this.day.id,
        automobile_id: 0,
        driver_id: 0,
      }
      this.search_driver = ''
      this.search_auto = ''
      this.auto_selected = true
      this.dispather_selected = false
      this.price_selected = false
      this.filteredAutoList()
    },
    beforeClose() {
      this.$emit('changed')
      this.clearForm()
    },
  },
}
</script>

<style lang="sass">
.clear-btn-to-auto.el-button
  margin-top: 20px
.dl_price
  button
    margin-left: 0px
.info
  display: flex
  justify-content: flex-end
  align-items: center
  &__title
    font-size: 16px
    font-weight: 500
    margin-right: 20px
  &__select.el-select
    width: 300px
.bidDocuments
  margin: 40px 0 30px
  &__title
    margin-bottom: 15px
    font-weight: bold
    color: #f56c6c
  &__checkboxes
    display: flex
    flex-direction: column
    gap: 10px
    &-item
      display: flex !important
      align-items: center
      .el-checkbox__label
        white-space: normal
        word-break: break-word
</style>
